import { render, staticRenderFns } from "./AzureAuthLogin.vue?vue&type=template&id=0b825cbe&scoped=true"
import script from "./AzureAuthLogin.vue?vue&type=script&lang=js"
export * from "./AzureAuthLogin.vue?vue&type=script&lang=js"
import style0 from "./AzureAuthLogin.vue?vue&type=style&index=0&id=0b825cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b825cbe",
  null
  
)

export default component.exports